export const isStorybook = () => !!global.STORYBOOK_ENV;
